<script setup lang="ts">
// Inlines an SVG from assets/icons by name, inheriting the surrounding color.
const { name, size } = defineProps<{ name: string; size?: string }>()

const iconModules = import.meta.glob('../assets/icons/*.svg', {
  query: '?raw',
  import: 'default',
  eager: true,
})

const markup = computed(() => {
  const entry = Object.entries(iconModules).find(([path]) => path.endsWith(`/${name}.svg`))
  return (entry?.[1] as string) ?? ''
})
</script>

<template>
  <span class="sb-icon" :style="size ? { '--sb-icon-size': size } : undefined" v-html="markup" />
</template>

<style scoped lang="scss">
.sb-icon {
  display: inline-flex;
  line-height: 0;
  color: inherit;

  :deep(svg) {
    width: var(--sb-icon-size, 24px);
    height: var(--sb-icon-size, 24px);
    display: block;
    fill: currentColor;
  }
}
</style>
